export const CHANGE_CURRENT_DAY: 'PROGRAM_DAYS/CHANGE_CURRENT_DAY' = 'PROGRAM_DAYS/CHANGE_CURRENT_DAY';
export const FLUSH_PROGRAM_DAYS: 'PROGRAM_DAYS/FLUSH' = 'PROGRAM_DAYS/FLUSH';
export const REQUEST_DAY_SUCCESS: 'PROGRAM_DAYS/REQUEST_DAY_SUCCESS' = 'PROGRAM_DAYS/REQUEST_DAY_SUCCESS';
export const REQUEST_TODAY_SUCCESS: 'PROGRAM_DAYS/REQUEST_TODAY_SUCCESS' = 'PROGRAM_DAYS/REQUEST_TODAY_SUCCESS';
export const REQUEST_CALENDAR: 'PROGRAM_DAYS/REQUEST_CALENDAR' = 'PROGRAM_DAYS/REQUEST_CALENDAR';
export const REQUEST_CALENDAR_SUCCESS: 'PROGRAM_DAYS/REQUEST_CALENDAR_SUCCESS' =
	'PROGRAM_DAYS/REQUEST_CALENDAR_SUCCESS';
export const REQUEST_CALENDAR_TODAY_SUCCESS: 'PROGRAM_DAYS/REQUEST_CALENDAR_TODAY_SUCCESS' =
	'PROGRAM_DAYS/REQUEST_CALENDAR_TODAY_SUCCESS';
export const REQUEST_CALENDAR_PROGRAM_DAY_TODOS_SUCCESS: 'PROGRAM_DAYS/REQUEST_CALENDAR_PROGRAM_DAY_TODOS_SUCCESS' =
	'PROGRAM_DAYS/REQUEST_CALENDAR_PROGRAM_DAY_TODOS_SUCCESS';
export const REQUEST_MOVE_ITEM: 'PROGRAM_DAYS/MOVE_ITEM' = 'PROGRAM_DAYS/MOVE_ITEM';
